module.exports = __webpack_public_path__ + "static/media/19ESCAP32.5d665a9b.jpg";